import request from '../request'
import axios from 'axios'

/**
 * 获取优惠券
 */
export function getCoupon(data) {
  return request({
    url: '/app/pk/coupon/insertRecord',
    method: 'POST',
    data
  })
}

/**
 * 获取停车信息
 */
export function getParkingInfo(params) {
  return request({
    url: '/app/pk/getWaitPayOrder',
    method: 'get',
    params
  })
}

/**
 * 立即缴费
 */
export function parkingPay(data) {
  return request({
    url: '/app/pk/pkPreOrder',
    method: 'post',
    data
  })
}

/**
 * 查询车场是否使用微信 JSAPI 支付
 */
export function getIsWechatPayPark(params) {
  return request({
    url: '/app/pk/isWechatPayPark',
    method: 'get',
    params
  })
}

/**
 * 获取车场车道信息
 */
export function getBarrierRoadWays(params) {
  return request({
    url: '/app/pk/RoadWay/getMapListByParkId',
    method: 'get',
    params
  })
}

/**
 * 远程开闸或关闸
 */
export function operateBarrier(params) {
  return request({
    url: '/app/pk/RoadWay/optBarrier',
    method: 'get',
    params,
    returnEnvelope: true
  })
}

/**
 * 获取订单支付状态
 */
export function getOrderStatus(params) {
  return request({
    url: '/app/pk/pkQueryTradeOrder',
    method: 'get',
    params
  })
}

/**
 * 无车牌入场
 */
export function noPlateIn({ plateNo, parkId, laneCode, loginCode }) {
  return request({
    url: '/app/pk/noPlateNo/goIn',
    method: 'post',
    params: {
      plateNo,
      parkId,
      laneCode,
      loginCode
    }
  })
}

/**
 * 无车牌出场
 */
export function noPlateOut({ plateNo, parkId, laneCode, loginCode }) {
  return request({
    url: '/app/pk/noPlateNo/goOut',
    method: 'post',
    params: {
      plateNo,
      parkId,
      laneCode,
      loginCode
    }
  })
}

/**
 * 查询公众号用户绑定的车牌
 */
export function getPlateNoByLoginCode(params) {
  return request({
    url: '/app/pk/noPlateNo/getPlateNoByLoginCode',
    method: 'get',
    params
  })
}

/**
 * 绑定公众号用户与首次入场车牌
 */
export function bindNoPlate(params) {
  return request({
    url: '/app/pk/user/plate/bind',
    method: 'post',
    params
  })
}

/**
 * 获取无车牌通行产生的待支付订单
 */
export function getNoPlateWaitPayOrder(params) {
  return request({
    url: '/app/pk/noPlateNo/getWaitPayOrder',
    method: 'get',
    params
  })
}

/**
 * 根据车牌号码查询订单记录
 */
export function getPkValidOrderPage(data) {
  return request({
    url: 'app/barrier/sd/getPkValidOrderPage',
    method: 'post',
    data
  })
}

/**
 * 获取场站开票信息
 */
export function getInvoicePkInfo(params) {
  return request({
    url: 'app/barrier/sd/getInvoicePkInfo',
    method: 'get',
    params
  })
}

/**
 * 开票申请
 */
export function applyInvoice(data) {
  return request({
    url: 'app/barrier/sd/applyInvoice',
    method: 'post',
    data
  })
}

/**
 * 获取跳转到小程序的schema码
 */
export function getSchemaCode(params) {
  return axios({
    url: process.env.VUE_APP_BASE_URL + 'app/pk/getSchemeCode',
    method: 'get',
    params
  })
}
